const convertSearchParams = (params) => {
  if (!params) return [];

  return params.split('-');
};

export default convertSearchParams;
